import React from 'react';
import classes from './Project.css';
import Button from '../UI/Button/Button';
import expCardImage from '../../assets/img/exp-bg.jpg';
import button from '../UI/Button/Button';
import LoadMoreText from '../UI/LoadMoreText/LoadMoreText';
const project = (props) => {
    let cardClass = classes.appCard;
    if(props.commercial) {
        cardClass = classes.appCardCommerical;
    }

    const buttons = [];
    if(props.github) {
        buttons.push(<Button  key={props.github} iconBtn isLink href={props.github} blank isPrimary><i className="fa fa-github"></i> </Button>);
    }

    if(props.online) {
        buttons.push(<Button  key={props.online}  iconBtn isLink href={props.online} blank isPrimary><i className="fa fa-eye"></i></Button>);
    }
 return (  <div className={cardClass} >
                <div className={classes.appHeading}>
                    <img src={props.posterImage?props.posterImage:expCardImage} />
                    <div className={classes.appCardTitle}>{props.name?props.name:null}</div> 
                </div>
                <div className={classes.appCardBody}>
                    <LoadMoreText charLength="420">
                    {props.description?props.description:null}
                    </LoadMoreText>
                </div>
                <div className={classes.appCardFooter} >{buttons}</div>
    </div>);
};


export default project;


// WEBPACK FOOTER //
// ./src/components/Project/Project.js